import React, { useState } from "react";
import "../App.css";

function Login({ onLogin }) {
  const [userName, setUserName] = useState("");
  const [pass, setPass] = useState("");
  const [error, setError] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}api/login`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ userName, pass }),
        }
      );

      if (!res.ok) {
        const { error } = await res.json();
        setError(error || "Invalid credentials");
        return;
      }

      const data = await res.json();
      onLogin(data.user); // store logged-in user in App
    } catch (err) {
      console.error("Login error:", err);
      setError("Server error — please try again later.");
    }
  };

  return (
    <div style={{ textAlign: "center", marginTop: "100px" }}>
      <h1 className="main-title">Login to MySnap</h1>
      <br /><br /><br />

      <form
        onSubmit={handleLogin}
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "20px",
          maxWidth: "320px",
          margin: "40px auto",
          padding: "20px",
          background: "rgba(0,0,0,0.7)",
          border: "2px solid rgb(197, 176, 55)",
          borderRadius: "12px",
          boxShadow: "0 0 15px rgba(255, 215, 0, 0.3)",
        }}
      >
        <input
          type="text"
          placeholder="Username"
          value={userName}
          onChange={(e) => setUserName(e.target.value)}
          required
          style={{
            background: "#111",
            color: "rgb(197, 176, 55)",
            border: "1px solid rgb(197, 176, 55)",
            borderRadius: "6px",
            padding: "8px",
            fontSize: "1rem",
          }}
        />

        <input
          type="password"
          placeholder="Password"
          value={pass}
          onChange={(e) => setPass(e.target.value)}
          required
          style={{
            background: "#111",
            color: "rgb(197, 176, 55)",
            border: "1px solid rgb(197, 176, 55)",
            borderRadius: "6px",
            padding: "8px",
            fontSize: "1rem",
          }}
        />

        {error && <p style={{ color: "red", fontSize: "0.9rem" }}>{error}</p>}

        <button type="submit" className="button">
          Log In
        </button>
      </form>
    </div>
  );
}

export default Login;
